import http from "@/lib/http";
export const getTrainers = async () => {
  const {
    data
  } = await http.get(`https://api.hachion.co/trainers/summary`);
  return data || [];
};
